(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    function initProductCardFrameArrows() {
    var cards = document.querySelectorAll('[data-product-card-gallery]');

    cards.forEach(function (card) {
      var section = card.closest('section') || card.parentElement;
      if (!section || section.dataset.productFrameArrowsReady === 'true') return;

      var sectionCards = section.querySelectorAll('[data-product-card-gallery]');
      if (sectionCards.length < 2) return;

      section.dataset.productFrameArrowsReady = 'true';
      section.style.position = 'relative';

      var prev = document.createElement('button');
      var next = document.createElement('button');

      prev.type = 'button';
      next.type = 'button';

      prev.className = 'product-card-frame-arrow product-card-frame-arrow--prev';
      next.className = 'product-card-frame-arrow product-card-frame-arrow--next';

      prev.setAttribute('aria-label', 'Scroll products left');
      next.setAttribute('aria-label', 'Scroll products right');

      prev.textContent = '‹';
      next.textContent = '›';

      section.appendChild(prev);
      section.appendChild(next);

      function scrollProducts(direction) {
        var amount = Math.round(window.innerWidth * 0.75);

        section.scrollBy({
          left: amount * direction,
          behavior: 'smooth'
        });
      }

      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollProducts(-1);
      });

      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollProducts(1);
      });
    });
  }

  initProductCardFrameArrows();

  document.addEventListener('shopify:section:load', initProductCardFrameArrows);
  } catch(e) { console.error(e); }
})();

})();
